import { motion } from 'framer-motion';
import { Github, Twitter, MessageCircle, Zap, ExternalLink } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-cyber-purple/20 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* 品牌 */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyber-purple to-cyber-blue flex items-center justify-center">
                <Zap className="w-6 h-6 text-white" />
              </div>
              <span className="font-display text-xl font-bold bg-gradient-to-r from-cyber-purple to-cyber-blue bg-clip-text text-transparent">
                MONAD x402
              </span>
            </div>
            <p className="text-gray-400 text-sm max-w-md mb-4">
              基于 Monad 测试网和 x402 协议的加密货币走势预测服务。
              使用 Kronos AI 模型提供专业级价格预测。
            </p>
            <div className="flex items-center gap-4">
              <SocialLink href="#" icon={Github} label="GitHub" />
              <SocialLink href="#" icon={Twitter} label="Twitter" />
              <SocialLink href="#" icon={MessageCircle} label="Discord" />
            </div>
          </div>

          {/* 链接 */}
          <div>
            <h4 className="text-white font-bold mb-4">资源</h4>
            <ul className="space-y-2">
              <FooterLink href="#">文档</FooterLink>
              <FooterLink href="#">API 参考</FooterLink>
              <FooterLink href="#">示例代码</FooterLink>
              <FooterLink href="#">常见问题</FooterLink>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">生态</h4>
            <ul className="space-y-2">
              <FooterLink href="https://monad.xyz" external>Monad</FooterLink>
              <FooterLink href="https://x402.org" external>x402 协议</FooterLink>
              <FooterLink href="https://huggingface.co/NeoQuasar" external>Kronos 模型</FooterLink>
              <FooterLink href="https://testnet.monadexplorer.com" external>区块浏览器</FooterLink>
            </ul>
          </div>
        </div>

        {/* 底部 */}
        <div className="border-t border-cyber-purple/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © 2025 Monad x402 Prediction Service. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              服务条款
            </a>
          </div>
        </div>

        {/* 风险提示 */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mt-8 p-4 rounded-xl bg-cyber-yellow/5 border border-cyber-yellow/20"
        >
          <p className="text-cyber-yellow/80 text-xs text-center">
            ⚠️ 风险提示：加密货币市场波动剧烈，本服务提供的预测仅供参考，不构成投资建议。
            请根据自身风险承受能力谨慎决策。
          </p>
        </motion.div>
      </div>
    </footer>
  );
}

function SocialLink({ href, icon: Icon, label }: { href: string; icon: any; label: string }) {
  return (
    <a
      href={href}
      aria-label={label}
      className="w-10 h-10 rounded-lg bg-cyber-dark/50 border border-gray-700 flex items-center justify-center text-gray-400 hover:text-white hover:border-cyber-purple/50 transition-all"
    >
      <Icon className="w-5 h-5" />
    </a>
  );
}

function FooterLink({ href, children, external }: { href: string; children: React.ReactNode; external?: boolean }) {
  return (
    <li>
      <a
        href={href}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
        className="text-gray-400 hover:text-white text-sm transition-colors flex items-center gap-1"
      >
        {children}
        {external && <ExternalLink className="w-3 h-3" />}
      </a>
    </li>
  );
}

